export default () => ({
    formContainer: {
        padding: 20
    },
    input: {
        flex: 1
    }
})